import store from '@/store'
import { useLazyQuery } from '@vue/apollo-composable';
import * as api from '@/api/okaso-api'


export type SearchLargeCategoriesCondition = {}

export function useSearchLargeCategoriesFunc() {

  const getWhere = (condition: SearchLargeCategoriesCondition) => {
    const where: api.LargeCategoryWhereInput  = {}
    return where
  }

  const {
    load: searchLargeCategoriesLoad,
    refetch: searchLargeCategoriesRefetch,
    onResult: searchLargeCategoriesOnResult,
    onError: searchLargeCategoriesOnError
  } = useLazyQuery<
    api.LargeCategoriesQuery,
    api.LargeCategoriesQueryVariables
  >(api.LargeCategoriesDocument, undefined)

  const searchLargeCategoriesFetchOrRefetch = (variables:api.LargeCategoriesQueryVariables) => {
    searchLargeCategoriesLoad(api.LargeCategoriesDocument, variables) || searchLargeCategoriesRefetch(variables)
  }

  const searchLargeCategories = ( condition: SearchLargeCategoriesCondition ) => {
    const where = getWhere(condition)
    // 検索実行
    searchLargeCategoriesFetchOrRefetch({
      where,
      orderBy: [
        {
          seq: {
            sort: api.SortOrder.Asc
          }
        }
      ]
    })
  }

  return {
    searchLargeCategories,
    searchLargeCategoriesOnResult,
    searchLargeCategoriesOnError
  };
}
